const fallbackVersion =
  typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0'
const fallbackBuildNumber =
  typeof __BUILD_NUMBER__ === 'string' ? __BUILD_NUMBER__ : 'local'
const fallbackBuildCommit =
  typeof __BUILD_COMMIT__ === 'string' ? __BUILD_COMMIT__ : ''

const version = import.meta.env.VITE_APP_VERSION || fallbackVersion
const environment = import.meta.env.VITE_APP_ENV || 'development'
const buildNumber = import.meta.env.VITE_BUILD_NUMBER || fallbackBuildNumber
const buildCommit = import.meta.env.VITE_BUILD_COMMIT || fallbackBuildCommit
const shortCommit = buildCommit ? buildCommit.slice(0, 7) : ''

export const buildInfo = Object.freeze({
  version,
  environment,
  buildNumber,
  buildCommit,
  shortCommit,
  label: `v${version} · ${environment} · build ${buildNumber}${
    shortCommit ? ` · ${shortCommit}` : ''
  }`,
})
